import React, { FC } from 'react';

import useModalCreateOrdersHook from './modal-create-orders-hooks';
import ModalCreateOrdersScene from './modal-create-orders-scene';

type ModalCreateOrdersProps = {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
};

const ModalCreateOrders: FC<ModalCreateOrdersProps> = ({ open, onClose, onCancel }) => {
  const {
    t,
    methods,
    transactionTypes,
    types,
    workflows,
    selectTransactionType,
    handleOnSubmit
  } = useModalCreateOrdersHook(onCancel, open);

  return (
    <ModalCreateOrdersScene
      t={t}
      open={open}
      methods={methods}
      transactionTypes={transactionTypes}
      types={types}
      workflows={workflows}
      onClose={onClose}
      onCancel={onCancel}
      selectTransactionType={selectTransactionType}
      handleOnSubmit={handleOnSubmit}
    />
  );
};

export default ModalCreateOrders;
